import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { logOut } from "../features/auth/authSlice";
import secret from "../secret.json";
import "./UserMenu.css";

// 상단 바 오른쪽의 로그인 계정 표시. 누구로 들어와 있는지 보이고 로그아웃할 수 있다.
const UserMenu = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // 메뉴 밖을 누르면 닫는다.
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const closeOnOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, [isOpen]);

  // 학원 계정에 묶인 선생님은 학원 계정으로 들어오지만 이름은 본인 것(acting_name)을 보인다
  const displayName = user.acting_name || user.name || user.nickname || "선생님";
  const organizationName = user.organization_name || "";

  // 서버가 주는 plan 은 basic/plus/premium 처럼 전부 소문자라 그대로 쓰면 이름처럼 안 읽힌다.
  const planLabel = user.plan ? user.plan.charAt(0).toUpperCase() + user.plan.slice(1) : "";
  // 정원 소진율. 학생 수는 /api/v1/user/me 가 student_count 로 함께 준다.
  const capacityLabel = user.max_student_capacity
    ? `(${user.student_count ?? 0}/${user.max_student_capacity}명)`
    : `(${user.student_count ?? 0}명)`;

  const handleLogOut = () => {
    if (!window.confirm("로그아웃하시겠습니까?")) {
      return;
    }
    setIsOpen(false);
    dispatch(logOut());

    // 우리 토큰만 지우면 소용이 없다. 로그인이 지인에듀 OAuth 라서, 그쪽 세션이 살아
    // 있으면 다음 로그인 화면에서 곧바로 승인돼 되돌아온다. 모 서비스도 함께 끊는다.
    window.location.href = `${secret.GINEDU_BASE_URL}/accounts/logout/`;
  };

  return (
    <div ref={containerRef} className="user-menu">
      <button
        type="button"
        className={`user-menu__trigger ${isOpen ? "user-menu__trigger--open" : ""}`}
        onClick={() => setIsOpen((previous) => !previous)}
      >
        <span className="user-menu__name">{displayName}</span>
        <span className="user-menu__caret">▼</span>
      </button>

      {isOpen && (
        <div className="user-menu__dropdown">
          <div className="user-menu__summary">
            <div className="user-menu__display-name">{displayName}</div>
            {organizationName && (
              <div className="user-menu__organization">{organizationName}</div>
            )}
            {planLabel && (
              <div className="user-menu__plan">
                {planLabel} 플랜{" "}
                <span className="user-menu__capacity">{capacityLabel}</span>
              </div>
            )}
          </div>

          <button
            type="button"
            className="user-menu__item user-menu__item--danger"
            onClick={handleLogOut}
          >
            로그아웃
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
